// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"aa3e8260","455":"5c9efc99"}[chunkId] + ".chunk.js";
};